import { Record } from 'immutable';
export default Record({
  firstName: null,
  lastName: null,
  email: null,
  signedAt: null,
  avatarUrl: null,
  vid: null,
  userId: null
}, 'QuoteSignerRecord');